/* eslint-disable */
import { IAddressCadastreSchema } from '../address_cadastre/AddressCadastreSchema';
import { IDocumentFileSchema } from '../document_file/DocumentFileSchema';

export interface IV1ProcessFormAnswersRequestSchema {
  /** Адрес объекта/Кадастровый номер **/
  addressCadastre?: IAddressCadastreSchema | null;
  /** Оставьте ваш адрес электронной почты **/
  applicantEmail?: string | null;
  /** Как вас зовут? **/
  applicantName?: string | null;
  /** Оставьте ваш номер мобильного телефона **/
  applicantPhone?: string | null;
  /** Загрузите фото правоустанавливающего документа на {object_type} **/
  entitlementDocument?: IDocumentFileSchema[] | null;
  /** Идентификатор черновика ответов **/
  legalCheckId?: number | null;
  /** Какую недвижимость хотите проверить? **/
  objectType: EObjectType;
  /** Приложите другие документы **/
  otherDocuments?: IDocumentFileSchema[] | null;
  /** Загрузите фото паспорта собственника {object_type} **/
  sellerPassport?: IDocumentFileSchema[] | null;
  /** Код шага формы с которого пришли ответы **/
  stepCode: EStepCode;
}
export enum EObjectType {
  /** Квартира **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
  /** Участок **/
  'Land' = 'land',
  /** Комната **/
  'Room' = 'room',
}
export enum EStepCode {
  /** Проверка регистрации в Росреестре **/
  'AddressCadastre' = 'addressCadastre',
  /** Проверка регистрации участка в Росреестре **/
  'AddressCadastreHouse' = 'addressCadastreHouse',
  /** Оставьте ваш адрес электронной почты **/
  'ApplicantEmail' = 'applicantEmail',
  /** Как вас зовут? **/
  'ApplicantName' = 'applicantName',
  /** Оставьте ваш номер мобильного телефона **/
  'ApplicantPhone' = 'applicantPhone',
  /** Загрузите фото правоустанавливающего документа на {object_type} **/
  'EntitlementDocument' = 'entitlementDocument',
  /** Какую недвижимость хотите проверить? **/
  'ObjectType' = 'objectType',
  /** Приложите другие документы **/
  'OtherDocuments' = 'otherDocuments',
  /** Осталось оплатить отчёт **/
  'PayForReport' = 'payForReport',
  /** Загрузите фото паспорта собственника {object_type} **/
  'SellerPassport' = 'sellerPassport',
}
